import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32787c19"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}


import { defineComponent, defineProps, onMounted } from 'vue'
import { useStore } from "vuex";
import { Notyf } from "notyf";
import { useI18n } from 'vue-i18n';

const props = defineProps(['appointmentData'])
const store = useStore()

const notyf = new Notyf()

const appointmentLink = process.env.BASE_URL + "appointment/";  // Use the environment variable

const generateAppointmentLink = (customerPin: string) => {
  const { locale } = useI18n();
  return `${appointmentLink}${customerPin}?lang=${locale.value}`;
}

const __default__ = defineComponent({
  name: "VetRecordTableRow",

  methods: {
    formatSchedule(schedule: string): string
    {
      // Split the schedule string by space
      const parts = schedule.split(' ');
      // Split the time part (parts[1]) by ':'
      const timeParts = parts[1].split(':');
      // Combine the date part (parts[0]) and only the hour and minute parts of the time
      return parts[0] + ' ' + timeParts[0] + ':' + timeParts[1];
    }
  }
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['appointmentData'],
  setup(__props) {


const props = __props
const store = useStore()

async function iniAppointmentData(showAppointmentData: any) {
  console.log("iniAppointmentData")
  console.log(store.getters.getShowingAppointmentData)

  await store.dispatch('iniEditedAppointment', showAppointmentData.appointment_id)
  console.log("back to iniAppointmentData")
  console.log(store.getters.getEditedAppointmentData)

  store.dispatch('toggleAppointmentDetailing', false)
  store.dispatch('toggleShowingAppointmentData', false)

}

onMounted(() => {
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatSchedule(__props.appointmentData.schedule)), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.customer_name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.pet_name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.appointment_status), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.status_date), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("a", {
        href: generateAppointmentLink(__props.appointmentData.vet_pin),
        class: "pointer"
      }, _toDisplayString(_ctx.$t('AppointmentData.Link')), 9, _hoisted_1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "button is-warning is-small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (iniAppointmentData(__props.appointmentData)))
        }, _toDisplayString(_ctx.$t('General.Details')), 1)
      ])
    ])
  ], 64))
}
}

})